import { Base } from "../base";

export class DateRange extends Base {
    StartDate?: Date;
    EndDate?: Date;
    Target?: string;

    constructor(startDate?: Date, endDate?: Date, target?: string) {
        super();
        this.StartDate = startDate;
        this.EndDate = endDate;
        this.Target = target;
    }
}